// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"380":"48b50dca","453":"7f5ef127"}[chunkId] + ".chunk.js";
};